
<div
  :class="
    classes(
      n(),
      n(`--${state.type}`),
      n(`--${state.background}`),
      n(`--${state.size}`),
    )
  "
  :style="tabsStyle"
>
  <!-- 标签栏区域 -->
  <div
    :class="
      classes(
        n('nav-wrapper'),
        [state.showGradient && hasOverflow && showLeftGradient, n('nav-wrapper--gradient-left')],
        [state.showGradient && hasOverflow && showRightGradient, n('nav-wrapper--gradient-right')],
      )
    "
  >
    <!-- 左侧插槽 -->
    <div
      v-if="$slots['nav-left']"
      :class="n('nav-left')"
    >
      <slot
        name="nav-left"
        :active-index="activeIndex"
      />
    </div>

    <!-- 标签栏 - liteapp 环境使用 scroll-view -->
    <scroll-view
      v-if="isLiteapp"
      ref="tabsNavRef"
      :class="n('nav')"
      scroll-x
      :scroll-left="scrollLeft"
      :scroll-with-animation="scrollWithAnimation"
      :show-scrollbar="false"
      @scroll="handleScrollViewScroll"
      @scrollend="handleScrollViewScrollEnd"
    >
      <div :class="n('nav-track')">
        <slot />
        <!-- 底部指示器 (仅 normal 类型) -->
        <div
          v-if="state.type === 'normal'"
          ref="indicatorRef"
          :class="n('indicator')"
          :style="indicatorStyle"
        />
      </div>
    </scroll-view>

    <!-- 标签栏 - H5 环境使用原生 div -->
    <div
      v-else
      ref="tabsNavRef"
      :class="n('nav')"
      @scroll="handleScroll"
    >
      <div :class="n('nav-track')">
        <slot />
        <!-- 底部指示器 (仅 normal 类型) -->
        <div
          v-if="state.type === 'normal'"
          ref="indicatorRef"
          :class="n('indicator')"
          :style="indicatorStyle"
        />
      </div>
    </div>

    <!-- 右侧插槽 -->
    <div
      v-if="$slots['nav-right']"
      :class="n('nav-right')"
    >
      <slot
        name="nav-right"
        :active-index="activeIndex"
      />
    </div>
  </div>

  <!-- 内容区域 -->
  <div
    v-if="state.swipeable"
    :class="n('content')"
  >
    <div
      :class="n('content-track')"
      :style="{
        transform: `translateX(-${activeIndexNum * 100}%)`,
        transition: state.animated ? `transform ${state.duration}ms ease` : 'none',
      }"
    >
      <slot name="content" />
    </div>
  </div>
</div>
